export default __webpack_public_path__ + "static/media/setion08_kv01.3595adef.png";